import eq from "lodash-es/eq"

import { THEME } from "@/3514/theme"
import { buildCssClassName } from "@/3514/utils"

import { EFreeResponsesTheme as ETheme } from "./free-responses.types"

function getQuestionInsertionClasses(cssIdentifier: string): string {
    return `
        .${cssIdentifier} { 
            text-align: initial; 
            text-wrap: pretty; 
            hyphens: auto;
            margin-bottom: 0; 
            color: ${THEME.COLORS.gray[100]};
            font-size: ${THEME.FONT_SIZES[14]}px;
            line-height: ${THEME.LINE_HEIGHTS[21]}px;
            font-weight: ${THEME.FONT_WEIGHTS[800]};
        } 
    `
}

const styles = {
    section: ({ theme }: { theme: ETheme }): string =>
        buildCssClassName(
            "flex",
            "flex-col",
            "gap-y-[25px]",
            "w-full",
            "items-center",
            "rounded-[10px]",
            eq(theme, ETheme.Blue) && "bg-blue-500",
            eq(theme, ETheme.Transparent) && "bg-transparent"
        ),
    form: (): string => "flex flex-col gap-y-[25px] w-full",
    fieldsContainer: (): string => "w-full flex flex-col gap-y-[10px]",
    field: (): string =>
        buildCssClassName(
            "flex",
            "flex-col",
            "pt-[10px]",
            "px-[12px]",
            "pb-[15px]",
            "bg-white",
            "rounded-[10px]",
            "border-[1px]",
            "border-blue-400"
        ),
    fieldWrapper: (): string => "flex flex-col",
    fieldTitle: (): string => "pt-[5px] px-[8px] pb-[15px] selection:bg-blue-400",
    fieldTitleContent: getQuestionInsertionClasses,
    fieldInput: (): string => "!p-[8px] selection:bg-blue-400",
    buttonContainer: (): string => "flex flex-col gap-y-[10px] items-center"
} as const

export { styles as freeResponsesStyles }
